import ProdutoDestaque from './ProdutoDestaque';

export default ProdutoDestaque;